<template>
  <div>
    <div class="handle_header">
      <el-card class="box-card">
        <div class="search">
          <el-form :inline="true">
            <el-form-item label="搜索">
              <el-input size="mini" v-model="option.name" placeholder="账户名称"></el-input>
              <el-input size="mini" v-model="option.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">查询</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="tableList">
      <el-button type="primary" size="mini" @click="derive">导出</el-button>
      <el-table :data="tableData" border style="width: 100%; margin-top: 10px"
        :row-style="{ 'font-size': '12px', color: '#324253' }"
        :header-row-style="{ 'font-size': '12px', color: '#8994A1' }">
        <el-table-column align="center" prop="name" label="账户名称"></el-table-column>
        <el-table-column align="center" prop="id_photo" label="身份证照片">
          <template slot-scope="scope">
            <div class="imags">
              <viewer :images="scope.row.id_photo.split('|')">
                <img :style="{ marginLeft: index == 1 ? '10px' : ''}" class="img" v-for="(src, index) in scope.row.id_photo.split('|')" :src="src" :key="index">
              </viewer>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="手机号">
          <template slot-scope="scope">
            <span @click="displayPhone(scope)">{{ scope.row.real_phone || scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="id_video" label="人脸视频">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;justify-content: center;">
              <video class="video" controls>
                  <source :src="scope.row.id_video" type="video/mp4" />
              </video>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="create_time" label="录入时间"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <!-- <router-link :to="'/user/edit/' + scope.row.id">编辑</router-link> -->
            <a style="margin-left: 10px;" href="javascript:;" @click="editRow(scope, scope.row.id)">编辑</a>
            <a style="margin-left: 10px;" href="javascript:;" @click="deleteRow(scope, scope.row.id)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="tableData.length > 0"
        style="display: flex;justify-content: flex-end;"
        background
        @current-change="handleCurrentChange"
        :current-page="option.pageNum"
        :page-size="option.pageSize"
        :page-sizes="[10]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
import axios from 'axios'

export default {
  name: "userList",
  data() {
    return {
      total: 0,
      option: {
        name: '',
        phone: '',
        pageNum: 1,
        pageSize: 10
      },
      tableData: [],
    };
  },
  methods: {
    displayPhone(scope) {
      if (scope.row.real_phone) {
        return;
      }
      
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }

      axios({
        url: 'https://rz.hnbzyl.com/query_mobile',
        method: 'post',
        data: { id: scope.row.id, source: 4, password: password }
      }).then(res => {
        return res.data;
      }).then(res => {
          console.log('查询结果', res);
           if (!res || res.code != 200) {
              alert('查询失败');
              return;
          }
          scope.row.real_phone = res.data;
      }).catch(function(){
          alert('查询失败');
      });
  
    },
    editRow(scope, id) {
      let that = this;
      console.log('编辑', id);
      var password = prompt('请输入安全码');
      if (!password) {
        return;
      }
      axios({
        url: 'https://rz.hnbzyl.com/check_pass',
        method: 'post',
        data: {
          password: password,
        }
      }).then(res => {
        res = res.data;
        console.log('编辑结果', res);
        if (!res || res.code != 200) {
          alert(res.msg || '编辑失败');
          return;
        }
        that.$router.push('/user/edit/' + id)
      }).catch(function(){
      });
    },
    deleteRow(scope, id) {
      console.log('删除', id);
      var password = prompt('请输入安全码');
      if (!password) {
        return;
      }
      axios({
        url: 'https://rz.hnbzyl.com/delete_user',
        method: 'post',
        data: {
          id: id,
          password: password,
        }
      }).then(res => {
        res = res.data;
        console.log('删除结果', res);
        if (!res || res.code != 200) {
          alert(res.msg || '删除失败');
          return;
        }
        this.tableData.splice(scope.$index, 1);
        alert('删除成功');
      }).catch(function(){
          alert('删除失败');
      });
    },
    derive(){
      var password = prompt('请输入安全码');
      if (!password) {
          return;
      }
      axios({
        url: 'https://rz.hnbzyl.com/download_xls',
        method: 'get',
        responseType: "blob",//重要配置
        params: {type: '个人认证', password: password,}
      }).then(res => {
        if (res.data.type == 'application/json') {
            alert('导出失败');
            return;
        }
        const aLink = document.createElement("a");
        let blob = new Blob([res.data])
        aLink.href = URL.createObjectURL(blob)
        aLink.setAttribute('download', '个人认证.xlsx') // 设置下载文件名称
        aLink.click()
      })
    },
    getList() {
      this.tableData = [];
  
      axios({
        url: `https://rz.hnbzyl.com/list_per_data`,
        method: 'get',
        params: this.option
      }).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      })
    },
    handleCurrentChange(val, currentPage) {
      this.option.pageNum = val;
      this.getList();
    },
    search() {
      this.getList();
    },
    reset() {
      this.option.name = '';
      this.option.phone = '';
      this.option.pageNum = 1;
      this.option.pageSize = 10;
      this.getList();
    },
  },
  activated() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.page {
  text-align: right;
}

.imags {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img {
  width: 80px;
  object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
.video{
  width: 80px;
  height: 80px;
  // object-fit: contain;
  cursor: pointer;
  border: 1px solid #999;
}
</style>